import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { Section, SectionTitle } from '../Section';
import { CtaBlock } from '../CtaBlock';
import { faqs } from '../../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <Section tone="panel" data-id="element-107" data-mp="122d90y9zdd7j">
      <SectionTitle eyebrow="❓ Frequently asked questions" data-id="element-108" data-mp="123odl0b92ozp">
        Everything you might be wondering
      </SectionTitle>

      <ul className="mx-auto mt-8 w-full max-w-2xl space-y-3" data-id="element-109" data-mp="1psppwyn7eka9">
        {faqs.map((faq, index) => {
        const isOpen = open === index;
        return <li key={faq.question} className="overflow-hidden rounded-xl border border-white/10 bg-ink-800" data-id="element-110" data-mp="1g3669qro2mec" data-mpi={index}>
              <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-start gap-3 px-4 py-4 text-left transition-colors duration-150 ease-out hover:bg-ink-700" data-id="element-111" data-mp="1kzegqqux5rf6">
                <span className="flex-1 text-[15px] font-bold leading-snug text-white" data-id="element-112" data-mp="2onw4fthvd8qq">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`mt-0.5 h-5 w-5 shrink-0 text-teal-bright transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-113" data-mp="2yga7cpkooleh" />
              </button>
              {isOpen ? <p className="px-4 pb-4 text-[15px] leading-relaxed text-white/65" data-id="element-114" data-mp="32h3wfm9v468y">
                  {faq.answer}
                </p> : null}
            </li>;
      })}
      </ul>

      <CtaBlock className="mt-10" headline="Ready? Your access is one click away" data-id="element-115" data-mp="3cgclq1ts8woz" />
    </Section>;
}